import { memo, useEffect, useState } from 'react'
import ApiService from '../services/ApiService';
import parse from 'html-react-parser';


function AcceptableUsePolicy() {

    const [Items, setItems] = useState({});

    const getAllData = async () => {
        const responce = await new ApiService().GET("/get-all-static-content");

        if (responce.data.status === '1') {
            setItems(responce.data.data);
        }
    };


    useEffect(() => {
        getAllData();
    }, [])


    return (<>
        <div className="ful-hei">
            {parse(Items?.acceptable_use_policy || '')}
        </div>
    </>)
}

export default memo(AcceptableUsePolicy)